// Ported from eb-ui packages/attendee/trending/src/components/TrendingSearches.tsx.
// Behaviour preserved: 100-per-page chunking + pagination, gettext -> local gettext,
// eds-pagination -> local Pagination, render-time onClick corrected to click-time
// (see SearchResults.tsx). Rendered only when the
// `launchConsolidateAndExpandTrendingSearches` flag is on.

import { chunk, isEmpty } from 'lodash';
import React, { useState } from 'react';
import { gettext } from '../i18n/gettext';
import { TrendingSearchResultsProps } from '../types';
import { formatSearchUrl } from '../utils';
import Pagination from './Pagination';

const MAX_RESULTS_PER_PAGE = 100;

const TrendingSearches = ({
    searches,
    location,
    displayLocation,
    shouldNoFollowLinks,
    onSearchClick,
    localeSubdirectory,
}: TrendingSearchResultsProps) => {
    const [page, setPage] = useState(1);

    const optionalLinkProps: { rel?: string } = {};
    if (shouldNoFollowLinks) {
        optionalLinkProps.rel = 'nofollow';
    }

    const pageCount = Math.ceil(searches.length / MAX_RESULTS_PER_PAGE);
    const searchChunk = chunk(searches, MAX_RESULTS_PER_PAGE);

    let content;

    if (searches.length > 0) {
        const pageIndex = page - 1;
        content = searchChunk[pageIndex].map((value, key) => (
            <div
                key={`${value.formatted}--${value.score}--${pageIndex * MAX_RESULTS_PER_PAGE + key}`}
                className="eds-g-cell eds-g-cell-12-12 eds-g-cell-md-6-12 eds-g-cell-lg-4-12"
            >
                <p className="trending-search-result eds-l-pad-all-6 eds-l-mar-right-4">
                    <span className="eds-l-mar-right-3">
                        {pageIndex * MAX_RESULTS_PER_PAGE + key + 1}.
                    </span>
                    <a
                        href={formatSearchUrl(location, value.formatted, localeSubdirectory)}
                        onClick={() => onSearchClick?.(value.term)}
                        {...optionalLinkProps}
                    >
                        {value.term}
                    </a>
                </p>
            </div>
        ));
    } else {
        content = (
            <div className="eds-g-cell eds-g-cell-12-12 eds-g-cell-md-12-12 eds-g-cell-lg-12-12">
                <p className="trending-search-result eds-l-pad-all-12 eds-l-mar-right-12">
                    {gettext('No trending searches for %(location)s.', {
                        location: displayLocation,
                    })}
                </p>
            </div>
        );
    }

    return (
        <div>
            <div id="trending-searches" className="eds-g-group trending-search-results">
                {content}
            </div>
            {!isEmpty(searches) && (
                <div data-testid="trending-searches-pagination">
                    <Pagination
                        pageNumber={page}
                        pageCount={pageCount}
                        onSelected={(pageNumber: number) => setPage(pageNumber)}
                        resultsPerPage={MAX_RESULTS_PER_PAGE}
                        totalNumResults={searches.length}
                        showOnSinglePage={false}
                    />
                </div>
            )}
        </div>
    );
};

export default TrendingSearches;
